import { pipe } from 'ramda';
import { createSelector } from 'reselect';
import { StateStatus } from '@alycecom/utils';

import { IRootState } from '../root.types';
import { getCountries } from '../countries/countries.selectors';

const pathToStatusesState = (state: IRootState) => state.geoIpCountry;

export const getIsLoaded = pipe(pathToStatusesState, state => state.status === StateStatus.Fulfilled);
export const getIsLoading = pipe(pathToStatusesState, state => state.status === StateStatus.Pending);

export const getDetectedCountry = pipe(pathToStatusesState, state => state.detectedCountry);

export const getDetectedCountryByCode = createSelector(getCountries, getDetectedCountry, (countries, country) =>
  countries.find(item => item.code === country?.code),
);

export const getIsSkipped = pipe(pathToStatusesState, state => state.isSkipped);
